import logs from "../../api/logs";
import { perPageCount } from "@/common/constants";
import { dummyRows } from "@/common/functions";

const getDefaultState = () => {
  return {
    items: [],
    loaded: false,
    filter: {
      page: 1,
      perPageCount: perPageCount,
      logType: "",
      user: "",
      list: "",
      search: "",
    },
    totalItems: 0,
    logFilters: "",
  };
};

// initial state
const state = getDefaultState();
// getters
const getters = {
  getLogItems: (state) => {
    if (!state.items.length && !state.loaded) {
      // return []
      return dummyRows();
    }
    return state.items;
  },
  getLogFilters: (state) => {
    return state.logFilters;
  },
  getParams: (state) => {
    return state.filter;
  },
};

// actions
const actions = {
  fetchItems({ commit, state }, params) {
    var filter = state.filter;
    if (
      !state.loaded ||
      filter.page !== params.page ||
      filter.perPageCount !== params.perPageCount
    ) {
      commit("setLoaded", false);
      commit("setFilter", { ...params });
      logs.fetchItems(params.logType, params, (data) => {
        commit("setItems", { items: data.items });
        commit("setLoaded", true);
        commit("setTotalItems", data.total);
      });
    }
  },

  resetItems({ commit, state, dispatch }) {
    commit("setItems", { items: [] });
    commit("setTotalItems", 0);
    dispatch("refreshItems", state.filter);
  },

  refreshItems({ commit, state, dispatch }) {
    commit("setLoaded", false);
    dispatch("fetchItems", state.filter);
  },

  resetState({ commit }) {
    commit("resetState");
  },

  fetchLogFilters({ commit, state }, params) {
    var filter = state.filter;
    if (
      !state.loaded ||
      filter.page !== params.page ||
      filter.perPageCount !== params.perPageCount
    ) {
      logs.fetchFilters(params.logType, params, (data) => {
        data.filterData.users.push({ label: "API User", value: "0" });
        commit("setLogFilters", data.filterData);
      });
    }
  },

  downloadImportSummary(_, params) {
    return logs.downloadSummary(params);
  },
};

// mutations
const mutations = {
  setItems(state, { items }) {
    if (state.filter.logType === "contact-logs") {
      items.map((item) => {
        if (item.logMessage) {
          item.logMessage = item.logMessage.replace(
            /<b__/g,
            '<span class="font-weight-bold">'
          );
          item.logMessage = item.logMessage.replace(/__b>/g, "</span>");
          item.logMessage = item.logMessage.replace(
            /<a__/g,
            '<span class="font-weight-bold text-primary">'
          );
          item.logMessage = item.logMessage.replace(/__a>/g, "</span>");
        }
        return item;
      });
    }
    state.items = items;
  },

  setFilter(state, data) {
    state.filter = data;
  },

  setTotalItems(state, total) {
    state.totalItems = total;
  },

  setLogFilters(state, filterData) {
    state.logFilters = filterData;
  },

  setLoaded(state, loaded) {
    state.loaded = loaded;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
